import React, { forwardRef } from 'react';
import { Autocomplete, Box, TextField } from '@mui/material';
import { IBoxFormAutocomplete } from 'src/components/profileComponents/FormAutocomplete/types';
import { RandomInteger } from 'src/helpers/randomInteger';
import CircularProgress from '@mui/material/CircularProgress';
import { useStyles } from './styles';

export const BoxFormAutocomplete = forwardRef<HTMLInputElement, IBoxFormAutocomplete>(({
  label, name, options, value, onChange, onBlur, onOpen, onClose, defaultValue, multiple, isLoading, propertyToCompare, disableClearable = true, disabled, errors,
}, ref) => {
  const styles = useStyles();
  return (
    <Box mb={6} width="100%" display="flex" flexDirection="column">
      { label && (
        <Box mb={2} className="label">
          { label }
        </Box>
      ) }
      <Box className={styles.wrapper}>
        <Autocomplete
          ref={ref}
          key={defaultValue}
          multiple={multiple || Array.isArray(value) || Array.isArray(defaultValue)}
          id={name}
          options={options}
          value={value || undefined}
          disabled={disabled}
          disableCloseOnSelect={Array.isArray(value)}
          disableClearable={disableClearable}
          onOpen={(event) => onOpen && onOpen(event)}
          onClose={(event) => onClose && onClose(event)}
          onChange={(ev, currValue, reason) => onChange && onChange(currValue, reason)}
          onBlur={onBlur}
          isOptionEqualToValue={(option, equalToValue) => {
            if (propertyToCompare) {
              return option.value?.[propertyToCompare] === equalToValue.value?.[propertyToCompare];
            }
            return JSON.stringify(option.value) === JSON.stringify(equalToValue.value);
          }}
          loading={isLoading}
          loadingText={<CircularProgress size={20} />}
          renderInput={(params) => (
            <TextField {...params} placeholder="" sx={{ fontSize: '14px' }} />
          )}
          sx={{
            '.MuiAutocomplete-endAdornment': {
              top: 'calc(50% - 12px)',
            },
          }}
          renderOption={(props, option) => {
            return (
              <li {...props} key={RandomInteger()}>
                { option.label }
              </li>
            );
          }}
          defaultValue={defaultValue}
        />
        {errors && name && errors[name] && (
          <Box className={`${styles.error}`}>
            {errors[name].message}
          </Box>
        )}
      </Box>
    </Box>
  );
});
